<div class="model savedrawer">
    <div class="model-body">
        <div class="header box-header">
            <!-- <i class="fas fa-exclamation-triangle" style="color: red;"></i> -->
            {{title}}
        </div>
        <div class="model-content">
            <div class="condition-container">
                <div class="condition">
                    {{message}}
                </div>

                <div class="button-container">
                    <button type='button' class="btn btn-danger confirm-btn"
                        (click)="closeConfirmationBox(true)">Yes</button> &nbsp;
                    <button class="btn btn-success confirm-btn" (click)="closeConfirmationBox(false)">No</button>
                </div>
            </div>
        </div>
    </div>
</div>